module.exports = __webpack_public_path__ + "images/rich_heading/small_appliance/bg_c1e50b3ded70269ee2d37778f8b25bd0.png";